import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import {
	getProtocols,
	updateProtocolsPagination
} from '../../store/actions/protocols/protocols_action';
import {
	Divider,
	makeStyles,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { formatDate } from '../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	paper: {
		width: '100%',
		marginTop: theme.spacing(3),
		overflowX: 'auto'
	},
	table: {
		minWidth: 500
		// whiteSpace: 'nowrap'
	},
	dateCell: {
		transform: 'rotate(300deg)'
	}
}));

const ProtocolsTable = ({
	protocols: { collection, totalCount, page, rowsPerPage, filters }
}) => {
	const { paper, table, tableRow, dateCell } = useStyles();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getProtocols({ page, rowsPerPage, filters }));
	}, [page, rowsPerPage]);

	return (
		<Paper className={paper}>
			<Table aria-label="table" className={table}>
				<TableHead>
					<TableRow>
						<TableCell>Redni broj</TableCell>
						<TableCell>Datum</TableCell>
						<TableCell>Prezime, ime jednog od roditelja i ime</TableCell>
						<TableCell>Godina rođenja</TableCell>
						<TableCell>
							Ulica i broj prebivališta - mesto, opština, republika
						</TableCell>
						<TableCell width="200">
							<ol>
								<li>Registarski broj</li>
								<li>Šifra delatnosti</li>
								<li>Broj zdravstvene knjižice</li>
							</ol>
						</TableCell>
						<TableCell>
							Kategorija zdravstvene zaštite opštinskog fonda
						</TableCell>
						<TableCell>Vid zdravstvene zaštite</TableCell>
						<TableCell>Anamneza i nalaz</TableCell>
						<TableCell>Dijagnoza</TableCell>
						<TableCell>Terapija</TableCell>
						<TableCell>Kome, kuda i kad je upućen</TableCell>
						<TableCell>Datum ponovnog javljanja</TableCell>
						<TableCell>Cena</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{collection.map(
						(
							{ uuid, startDate, customer, article, digitalRecord /*, worker*/ },
							index
						) => (
							<TableRow hover key={uuid} className={tableRow}>
								<TableCell align="center">
									{index + 1 + page * rowsPerPage}
								</TableCell>
								<TableCell className={dateCell} align="center">
									{formatDate(startDate)}
								</TableCell>
								<TableCell align="center">
									{customer?.lastName} {customer?.firstName}
								</TableCell>
								<TableCell align="center">
									{customer?.birthday ? formatDate(customer.birthday) : ''}
								</TableCell>
								<TableCell align="center">{customer?.address || '/'}</TableCell>
								<TableCell align="center">
									<Divider />
									<br />
									<Divider />
									<br />
									<Divider />
								</TableCell>
								<TableCell align="center">
									<br />
									<Divider />
									<br />
								</TableCell>
								<TableCell align="center"></TableCell>
								<TableCell align="center">{article?.name}</TableCell>
								<TableCell align="center">{digitalRecord[0]?.diagnosis}</TableCell>
								<TableCell align="center">
									{digitalRecord[0]?.digitalRecordTherapy
										?.map((therapy) => therapy.therapyName)
										.join(', ') || ''}
								</TableCell>
								<TableCell align="center">
									{/* {`${worker?.firstName}${' '}${worker?.lastName}` || ''} */}
								</TableCell>
								<TableCell align="center"></TableCell>
								<TableCell align="center">{article?.price}</TableCell>
							</TableRow>
						)
					)}
				</TableBody>
				<TablePagination
					page={page}
					count={totalCount}
					rowsPerPage={rowsPerPage}
					filters={filters}
					updatePagination={updateProtocolsPagination}
				/>
			</Table>
		</Paper>
	);
};

ProtocolsTable.propTypes = {
	protocols: PropTypes.object
};

const mapStateToProps = (state) => ({
	protocols: state.protocols
});

export default connect(mapStateToProps)(ProtocolsTable);
